export default "__VITE_ASSET__455cef39__"